import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum Langs {
  English = 'en',
  Korean = 'ko',
  Russian = 'ru',
}

@Injectable({
  providedIn: 'root',
})

export class TranslationService {
  public defaultLang = Langs.English;
  public langsList = [Langs.English];
  public currentLang: string = this.defaultLang;

  constructor(
    private translate: TranslateService,
  ) { }

  public initLang(): void {
    this.translate.addLangs(this.langsList);
    this.setCurrentLang(this.langsList[0]);
  }

  private listRegexp(): RegExp {
    return new RegExp(this.langsList.join('|'));
  }

  public setCurrentLang(lang: string): void {
    this.currentLang = lang.match(this.listRegexp()) ? lang : this.defaultLang;

    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }

  public get lang(): string {
    return this.currentLang;
  }
}
